import React, { useEffect } from 'react';

import Sidebar from './Sidebar'//import $ from "jquery";

import { Link } from 'react-router-dom';

import Barside from '../assets/img/Icons/Icons/Icon-17.png'
import ImgC1 from '../assets/img/Icons/Icons/ImgC1.png'

import ImgC2 from '../assets/img/Icons/Icons/ImgC2.png'
import ImgC3 from '../assets/img/Icons/Icons/ImgC3.png'
import Image4 from '../assets/img/Icons/Icons/imageC4.png'

import Imageb1 from '../assets/img/Icons/Icons/bagde-hero.png'


import Imgcard1 from '../assets/img/Icons/Icons/cameraI.jpg'
import RedL from '../assets/img/Icons/Icons/sm-barcode.png'


import MainImgSmall from '../assets/img/Icons/Icons/smallimgicon.png'

import LPin from '../assets/img/Icons/Icons/Lpin.png'
import Footer from '../pages/footer'
const WeeklyAd = () => {


    useEffect(() => {
        window.scrollTo(0, 0);
        $(window).on("load", function() {
            $('.carousel-container').each(function() {
                var $carouselContainer = $(this);
                var $carousel = $carouselContainer.find('.carousel').on('slid.bs.carousel', function() {
                    var targetSlide = $carousel.find('.active').index();
                    var targetContent = $carouselContainer.find('.slide-content[data-slide="' + targetSlide + '"]').html();
                    $carouselContainer.find('.carousel-text').html(targetContent);
                }).carousel({
                    interval: false
                });
                $carouselContainer.find('.carousel-selector').on('click', function() {
                    var targetSlide = $(this).data('slide');
                    $carousel.carousel(targetSlide);
                });
                var n = $carouselContainer.find(".slide-content").length;
                if (n < 2 || $carouselContainer.closest(".modal").length > 0) {
                    $carousel.trigger('slid.bs.carousel');
                } else {
                    $carousel.carousel(n - 1);
                    $carousel.trigger('slid.bs.carousel');
                }
            });
        })
 
    }, [])


    return (
        <div>
            <div className="bg-white border shadow  bg-bottom-round">
                <div className="container page17">
                    <div className="row mt-3">
                        <div className="col-sm-1-my17 ">
                            <Sidebar/>
                        </div>
                        <div className="col-sm-11-my17 text-center ">

                            <h5 className=" signin1-h1-top  mb-0">Weekly Add</h5>
                        </div>
                    </div>

                    <div className="row page17-p">
                        <div className="col-sm-12 py-2">
                            <hr className="mt-2" />

                            <div>
                                <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                                    <ol className="carousel-indicators carousel-indicators-numbers" style={{bottom:"-29px"}}>
                                        <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active">1</li>
                                        <li data-target="#carouselExampleIndicators" data-slide-to="1">2</li>
                                        <li data-target="#carouselExampleIndicators" data-slide-to="2">3</li>
                                    </ol>
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <img className="d-block w-100" src={ImgC1} alt="First slide" />
                                        </div>
                                        <div className="carousel-item">
                                            <img className="d-block w-100" src={ImgC2} alt="Second slide" />
                                        </div>
                                        <div className="carousel-item">
                                            <img className="d-block w-100" src={ImgC3} alt="Third slide" />
                                        </div>
                                    </div>
                                    <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="sr-only">Previous</span>
                                    </a>
                                    <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="sr-only">Next</span>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}

export default WeeklyAd;

